<template>
    <v-container
        class="align-start"
        fill-height
    >
        <div
            class="row no-gutters"
            width="100%"
        >
            <v-col>
                <loading-overlay :loading="loading" />
                <transfers-date-filters
                    title="Requests"
                    :is-requests="true"
                    @filter="loadRequests"
                />
                <div class="mt-48" />
                <v-data-iterator
                    :items="requests"
                    :items-per-page="pagination.requestPerPage"
                    :page.sync="pagination.page"
                    :loading="loading"
                    hide-default-footer
                    @page-count="pagination.pageCount = $event"
                >
                    <template v-slot:item="{ item: request }">
                        <v-row class="mb-4 no-gutters">
                            <request
                                :key="request.id"
                                :initial-request="request"
                                :initial-requestor="requestor"
                                :selected-order.sync="selectedOrder"
                                :requestor.sync="requestor"
                                style="width: 100%;"
                                @open-make-payment="openRequestDetails"
                            />
                        </v-row>
                    </template>
                    <template v-slot:footer>
                        <v-pagination
                            v-model="pagination.page"
                            :length="pagination.pageCount"
                            :total-visible="7"
                        />
                    </template>
                </v-data-iterator>

                <!-- <transfer-modal
                    v-if="showTransferModal"
                    ref="transferModal"
                    v-model="showTransferModal"
                    :currency="matcherCurrency"
                    :is-from-transfers="false"
                    :payment-types="[ selectedOrder.poster_payment_method_type ]"
                    :show-transfer-modal="showTransferModal"
                    :selected-order="selectedOrder"
                    :requestor="requestor"
                ></transfer-modal> -->

                <request-details-modal
                    v-model="showDetailsModal"
                    :request="selectedOrder"
                    @accept="openMakePayment"
                />

                <v-dialog
                    v-model="showFeeModal"
                    max-width="450px"
                >
                    <fee-wheel
                        v-if="selectedOrder.order"
                        :order-id="selectedOrder.order.id"
                        :currencyCode="selectedOrder.matcher_currency"
                        :pbToMatcherExchangeRate="selectedOrder.pb_to_matcher_exchange_rate"
                        @received="feeReceived"
                        :amount="selectedOrder.amount"
                    />
                </v-dialog>

                <request-accept-modal
                    ref="requestAcceptModal"
                    v-model="showTransferModal"
                    :request="selectedOrder"
                />
            </v-col>
        </div>
    </v-container>
</template>

<script>
    /* eslint-disable no-undef */
    /* eslint-disable camelcase */
    import request from './request.vue';
    import transfersDateFilters from './transfers/components/transfers-date-filter.vue';
    import MySocket from '../services/MySocket';
    // import transferModal from './transfers/components/transfer-modal.vue';
    import feeWheel from './transfers/components/fee-wheel.vue';
    import requestDetailsModal from './requests/request-details-modal.vue';
    import requestAcceptModal from './requests/request-accept-modal.vue';

    const currency = require('../modules/currency');

    export default {
        components: {
            request,
            transfersDateFilters,
            // transferModal,
            feeWheel,
            requestDetailsModal,
            requestAcceptModal,
        },
        data,
        mounted,
        beforeDestroy,
        methods: getMethods(),
    };

    function beforeDestroy() {
        removeSocketListeners();

        function removeSocketListeners() {
            MySocket.remove('orderRequested');
            MySocket.remove('paymentRequestAccepted');
            MySocket.remove('paymentRequestExpired');
            MySocket.remove('paymentRequestDeclined');
            MySocket.remove('paymentRequestDeleted');
        }
    }

    function mounted() {
        const vm = this;
        setupUiElements();
        addSocketListeners();
        this.getUserRequests.apply(this);
        vm.loading = true;

        function setupUiElements() {
            vm.$store.commit('pageHeaderClass', 'transfer');
            vm.$store.commit('pageHeaderTitle', vm.pageTitle);
            vm.$store.commit('mobileMenuIsVisible', true);
            vm.$store.commit('closeButtonIsVisible', false);
            vm.$store.commit('hideLogoPart', false);
        }

        function reloadIfUserIsRequestorOrBenefactor(paymentRequest) {
            const userId = vm.$store.state.user.id;
            if (paymentRequest.user_id === userId || paymentRequest.benefactor_user_id === userId) {
                vm.getUserRequests.apply(vm);
            }
        }

        function addSocketListeners() {
            MySocket.on('orderRequested', reloadIfUserIsRequestorOrBenefactor);
            MySocket.on('paymentRequestAccepted', reloadIfUserIsRequestorOrBenefactor);
            MySocket.on('paymentRequestExpired', reloadIfUserIsRequestorOrBenefactor);
            MySocket.on('paymentRequestDeclined', reloadIfUserIsRequestorOrBenefactor);
            MySocket.on('paymentRequestDeleted', reloadIfUserIsRequestorOrBenefactor);
        }
    }

    function data() {
        return {
            requests: [],
            showFeeModal: false,
            showDetailsModal: false,
            showTransferModal: false,
            loading: false,
            stateActive: false,
            stateInactive: false,
            pageTitle: 'Requests',
            selectedOrder: {},
            requestor: {},
            pagination: {
                requestPerPage: 3,
                page: 1,
                pageCount: 0,
            },
        };
    }

    function getMethods() {
        return {
            getFilteredRequests,
            getUserRequests,
            loadRequests,
            getCurrencyFromCode,
            openRequestDetails,
            openMakePayment,
            feeReceived,
            sortOrdersByDate,
        };

        function getUserRequests() {
            const vm = this;
            Vue.backendApi().paymentRequest()
                .getAll(vm.$store.state.user.id, { requestee: vm.$store.state.user.can_accept_offers })
                .then(success, errorHandler);

            function success(response) {
                vm.loading = false;

                if (response) {
                    Vue.set(vm, 'requests', []);
                    const requests = vm.sortOrdersByDate(response.data);
                    setTimeout(() => Vue.set(vm, 'requests', requests));
                }
            }

            function errorHandler(error) {
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'Error loading users requests',
                    text: error,
                });
            }
        }

        function getFilteredRequests(filters) {
            const vm = this;
            vm.loading = true;
            filters.requestee = vm.$store.state.user.can_accept_offers;
            Vue.backendApi().paymentRequest().getAll(vm.$store.state.user.id, filters).then(success, errorHandler);

            function success(response) {
                vm.loading = false;
                if (response) {
                    vm.requests = vm.sortOrdersByDate(response.data);
                }
            }

            function errorHandler(error) {
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'Error loading users requests',
                    text: error,
                });
            }
        }

        function loadRequests(filters) {
            const {
                state,
                start_date,
                end_date,
            } = filters;

            this.getFilteredRequests({
                status: state,
                start_date,
                end_date,
            });
        }

        function getCurrencyFromCode(currencyCode) {
            let c = currency.findCurrency(currencyCode);
            c = currency.addCurrencySteps(c);
            c = currency.addFlagLink(c);
            return c;
        }

        function openRequestDetails() {
            this.showDetailsModal = true;
        }

        function openMakePayment() {
            if (this.selectedOrder.order) {
                this.showFeeModal = true;
            } else {
                this.showTransferModal = true;
            }
        }

        function feeReceived(fee) {
            this.$set(this.selectedOrder.order, 'matcher_fee_id', fee.id);
            this.$set(this.selectedOrder.order, 'matcher_fee', fee.fee);
            this.showFeeModal = false;
            this.showTransferModal = true;
        }

        function sortOrdersByDate(orders) {
            return orders.sort((value1, value2) => {
                const d1 = window.Vue.moment(value1.posted_at);
                const d2 = window.Vue.moment(value2.posted_at);
                return d2 - d1;
            });
        }
    }
</script>

<style scoped>
    .mt-48 {
        margin-top: 192px !important;
    }
</style>
<style>
    .theme--light.v-pagination .v-pagination__item {
        background: none !important;
        color: #4147d6;
    }

    .v-pagination__item {
        border: none;
        box-shadow: none !important;
        font-style: normal;
        font-size: 14px;
        line-height: 136.5%;
        text-decoration: none;
    }

    .theme--light.v-pagination .v-pagination__item--active {
        font-weight: 800;
    }
</style>
